<template>

  <router-link :to="Route"  class="p-button-rounded p-button-primary p-button-text" v-tooltip.top="'Edit Assessment'">
    <i class="pi pi-pencil mr-2 mr-2"></i>
  </router-link>


  <Button icon="pi pi-pencil" class="p-button-rounded p-button-primary p-button-text" v-tooltip.top="'Edit Assessment'" @click="EditAssessment" />


  <!--<v-tooltip left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon
             v-bind="attrs"
             v-on="on"
             class="mx-0 px-0"
             color="primary"
             style="cursor:pointer;"
             :to="Route" alight="center">
        <v-icon color="rgb(209 131 15)" style="cursor:pointer"> mdi-pencil-outline </v-icon>
      </v-btn>
    </template>
    <span>Edit Assessment</span>
  </v-tooltip>-->

</template>


<script>
  /* eslint-disable vue/no-unused-components */
  /* eslint-disable no-debugger, no-unused-vars*/
  import Button from 'primevue/button';
  import Tooltip from 'primevue/tooltip';

    export default  {
    name: 'EditSingleRowLink',
    components: {
      Button,
      Tooltip
    },
    data: () => ({
        AssessmentId: null,
        Route:null
    }),
        beforeMount() {
        this.AssessmentId = this.params.data.id;
        this.Route = {
            name: 'CreateAssessment', params: { AssessmentId: this.AssessmentId, OrgId: this.params.data.orgId }
            }
    },
    EditAssessment() {
      debugger;
          this.$route.push('/')
      }
    };
</script>